import { Component, OnInit, ViewChild, SimpleChanges, Input, AfterViewInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { TiquetsService } from 'app/sections/tiquets/services/tiquets.service';
import { TiquetsClientFilter } from '../tiquets-client-filter/tiquets-client-filter';
import { TiquetsClient } from '../model/tiquets-client.model';
import { TiquetsClientFilterService } from '../../services/tiquets-client-filter.service';
import { TiquetsClientService } from '../../services/tiquets-client.sevice';

@Component({
  selector: 'app-tiquets-client-table',
  templateUrl: './tiquets-client-table.component.html',
  styleUrls: ['./tiquets-client-table.component.scss']
})
export class TiquetsClientTableComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  currentFilter: TiquetsClientFilter = new TiquetsClientFilter('id', 'desc'); // Filtro concreto para esta tabla.
  _sharedFilter: TiquetsClientFilter; // Filtro compartido por todas las tablas (mismos paramertos de filtrado en todas).
  @Input() get sharedFilter() {
    return this._sharedFilter;
  } set sharedFilter(val) {
    if (val !== undefined && val !== null) {
      this._sharedFilter = val;

      this.currentFilter.id = val.id;
      this.currentFilter.matricula = val.matricula;
      this.currentFilter.email = val.email;
      this.currentFilter.fechaTicketInicio = val.fechaTicketInicio;
      this.currentFilter.fechaTicketFin = val.fechaTicketFin;
      this.currentFilter.zona = val.zona;
      this.currentFilter.proveidors = val.proveidors;
    }
  }

  dataSource: CustomDataSource<TiquetsClient, TiquetsClientFilter>;
  highlightedRows = [];

  @Output() currentCount: EventEmitter<number>;

  displayedColumns = ['tiquet','matricula', 'ZONA_TICKET', 'email', 'importTiquet', 'FECHA_TICKET', 'FECHA_FIN_TICKET', 'MINUTOS_DIF', 'ID_EXTERNO', 'PROVEEDOR_EXTERNO'];

  constructor(
    private tiquetsService: TiquetsClientService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
    this.currentCount  = new EventEmitter<number>();
  }

  //#region CICLO DE VIDA

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<TiquetsClient, TiquetsClientFilter>(this.paginator, new TiquetsClientFilterService(), 'urlGetTiquetsClient', 'urlGetTiquetsClientCount');

    this.dataSource.countSubject.subscribe(newCount => {
      this.currentCount.emit(newCount);
    });
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.load();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.currentFilter.updated()))
    .subscribe();

    this.load();
  }

  //#endregion

  //#region EVENTOS
  paginatorChanged(value: any) {
    // Actualizamos la informacion al detectar un cambio en la paginacion.
    this.load();
  }

  updateFilterFromParent(val) {
    // Cuando el componente parent nos pasa un nuevo filtro compartido, actualizamos.
    
    this.sharedFilter = val;
    this.load();
  }

  //#endregion

  //#region OTHERS
  load() {
    this.currentFilter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.currentFilter, this.i18n('No s\'han trobat registres per tiquets'));
  }

  generateExcel(): void {
    let filter = this.currentFilter;

    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.tiquetsService, filter, this.i18n('TiquetsClient'), this.sort.direction, this.sort.active)
    });
  }

  //#endregion

}
